export default __webpack_public_path__ + "img/pbot_appp_logo.d2823e5d.png";